export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14622.fc5fac5a.jpg";